import type { BusinessAnalysisSnapshot } from "../../shared/types";
import { mockBusinessAnalysis } from "../mocks/businessAnalysis";
import { getRequired, getWithFallback } from "./apiClient";

const cacheTtlMs = 30 * 60 * 1000;
let cached: { expiresAt: number; snapshot: BusinessAnalysisSnapshot } | undefined;
let inFlight: Promise<BusinessAnalysisSnapshot> | undefined;

export function getBusinessAnalysis(options: { realDataOnly?: boolean } = {}): Promise<BusinessAnalysisSnapshot> {
  if (options.realDataOnly) {
    return getRequired<BusinessAnalysisSnapshot>("/business/analysis");
  }

  if (cached && cached.expiresAt > Date.now()) return Promise.resolve(cached.snapshot);
  if (inFlight) return inFlight;
  inFlight = getWithFallback("/business/analysis", () => mockBusinessAnalysis)
    .then((snapshot) => {
      cached = { expiresAt: Date.now() + cacheTtlMs, snapshot };
      return snapshot;
    })
    .finally(() => { inFlight = undefined; });
  return inFlight;
}
